import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm]       = useState({ email: '', senha: '' });
  const [loading, setLoading] = useState(false);
  const [erro, setErro]       = useState('');
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const user = await login(form.email, form.senha);
      navigate(user.perfil === 'master' ? '/master' : '/admin');
    } catch (err) {
      setErro(err.response?.data?.erro || 'E-mail ou senha incorretos. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--secondary)',
    }}>
      <div style={{
        background: 'var(--bg-card)', borderRadius: 'var(--radius-lg)',
        padding: '40px 36px', width: '100%', maxWidth: '400px',
        boxShadow: 'var(--shadow-lg)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>🍽</div>
          <h1 style={{ fontSize: '1.4rem', fontWeight: 700 }}>ArautoFood</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '.875rem', marginTop: '4px' }}>
            Acesso administrativo
          </p>
        </div>

        {erro && (
          <div style={{
            background: '#fee2e2', border: '1px solid #fca5a5',
            borderRadius: 'var(--radius)', padding: '12px 14px',
            marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px',
          }}>
            <span style={{ fontSize: '1.1rem' }}>⚠️</span>
            <span style={{ color: '#991b1b', fontSize: '.875rem', fontWeight: 500 }}>{erro}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">E-mail</label>
            <input
              className="form-control"
              type="email"
              placeholder="seu@email.com"
              value={form.email}
              onChange={e => { setErro(''); setForm(p => ({ ...p, email: e.target.value })); }}
              style={{ borderColor: erro ? '#fca5a5' : undefined }}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Senha</label>
            <input
              className="form-control"
              type="password"
              placeholder="••••••••"
              value={form.senha}
              onChange={e => { setErro(''); setForm(p => ({ ...p, senha: e.target.value })); }}
              style={{ borderColor: erro ? '#fca5a5' : undefined }}
              required
            />
          </div>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', marginTop: '4px', padding: '11px' }}>
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                <span style={{
                  width: 16, height: 16,
                  border: '2px solid rgba(255,255,255,.4)',
                  borderTopColor: '#fff', borderRadius: '50%',
                  animation: 'spin .7s linear infinite', display: 'inline-block',
                }} />
                Entrando...
              </span>
            ) : 'Entrar'}
          </button>
        </form>

        <p style={{
          textAlign: 'center', color: 'var(--text-muted)',
          fontSize: '.75rem', marginTop: '24px',
        }}>
          desenvolvido por GenPac Sistemas
        </p>
      </div>
    </div>
  );
}
